module.exports = __webpack_public_path__ + "img/ball2_xn.98015c6f.png";